import * as fromDatatype from '../datatype-library/index';

export interface bl_msg_message_attachment_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  message_guid: fromDatatype.GuidDataFieldInterface;
  file_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_msg_message_attachment_RowClass implements bl_msg_message_attachment_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  message_guid: fromDatatype.GuidDataFieldInterface;
  file_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

